export class ButtonTypes {
    static button_mini_fab: string = 'mat-mini-fab';
    static button_fab: string = 'mat-fab';
    static button_raised: string = 'mat-raised-button';
    static button_flat: string = 'mat-button';
    static button_toolbar: string = 'mat-button-toolbar';
    static button_icon: string = 'mat-icon-button';
    static button_menu_item: string = 'mat-menu-item';

}